<template>
  <!-- <div class="app-container"> -->
  <div class="">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <!-- <el-form-item label="主键" prop="pid">
        <el-input
          v-model="queryParams.pid"
          placeholder="请输入主键"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="租户" prop="tenantId">
        <el-input
          v-model="queryParams.tenantId"
          placeholder="请输入租户"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item label="编号" prop="qualificationNo">
        <el-input
          v-model="queryParams.qualificationNo"
          placeholder="请输入编号"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="证书名称" prop="certificateName">
        <el-input
          v-model="queryParams.certificateName"
          placeholder="请输入证书名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="证书编号" prop="certificateNumber">
        <el-input
          v-model="queryParams.certificateNumber"
          placeholder="请输入证书编号"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <!-- <el-form-item label="证书生效开始" prop="effectBegin">
        <el-date-picker clearable
          v-model="queryParams.effectBegin"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择证书生效开始">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="证书生效结束" prop="effectEnd">
        <el-date-picker clearable
          v-model="queryParams.effectEnd"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择证书生效结束">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="附件" prop="appIds">
        <el-input
          v-model="queryParams.appIds"
          placeholder="请输入附件"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="版本" prop="version">
        <el-input
          v-model="queryParams.version"
          placeholder="请输入版本"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['creditlibrary:businessqualification:add']"
        >新增</el-button>
      </el-col>
      <!-- <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['creditlibrary:businessqualification:edit']"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['creditlibrary:businessqualification:remove']"
        >删除</el-button>
      </el-col> -->
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['creditlibrary:businessqualification:export']"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="businessqualificationList" @selection-change="handleSelectionChange"   max-height="650">
      <el-table-column type="selection" width="40" align="center" />
      <!-- <el-table-column label="主键" align="center" prop="pid" />
      <el-table-column label="租户" align="center" prop="tenantId" /> -->
      <el-table-column label="编号" align="center" prop="qualificationNo" />
      <el-table-column label="证书名称" align="center" prop="certificateName" />
      <el-table-column label="证书编号" align="center" prop="certificateNumber" />
      <el-table-column label="证书生效开始" align="center" prop="effectBegin" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.effectBegin, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="证书类型" align="center" prop="certificateType" />
      <el-table-column label="证书生效结束" align="center" prop="effectEnd" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.effectEnd, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="附件" align="center" prop="appIds" />
      <el-table-column label="版本" align="center" prop="version" />
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['creditlibrary:businessqualification:edit']"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['creditlibrary:businessqualification:remove']"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改企业资质对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <!-- <el-form-item label="主键" prop="pid">
          <el-input v-model="form.pid" placeholder="请输入主键" />
        </el-form-item>
        <el-form-item label="租户" prop="tenantId">
          <el-input v-model="form.tenantId" placeholder="请输入租户" />
        </el-form-item> -->
        <el-form-item label="编号" prop="qualificationNo">
          <el-input v-model="form.qualificationNo" placeholder="请输入编号" />
        </el-form-item>
        <el-form-item label="证书名称" prop="certificateName">
          <el-input v-model="form.certificateName" placeholder="请输入证书名称" />
        </el-form-item>
        <el-form-item label="证书编号" prop="certificateNumber">
          <el-input v-model="form.certificateNumber" placeholder="请输入证书编号" />
        </el-form-item>
        <el-form-item label="证书生效开始" prop="effectBegin">
          <el-date-picker clearable
            v-model="form.effectBegin"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择证书生效开始">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="证书生效结束" prop="effectEnd">
          <el-date-picker clearable
            v-model="form.effectEnd"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择证书生效结束">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="附件" prop="appIds">
          <el-input v-model="form.appIds" placeholder="请输入附件" />
        </el-form-item>
        <!-- <el-form-item label="版本" prop="version">
          <el-input v-model="form.version" placeholder="请输入版本" />
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listBusinessqualification, getBusinessqualification, delBusinessqualification, addBusinessqualification, updateBusinessqualification } from "@/api/creditlibrary/businessqualification";

export default {
  name: "Businessqualification",
  data() {
    return {
      // 遮罩层
      loading: true,
      // loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 企业资质表格数据
      businessqualificationList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pid: null,
        tenantId: null,
        qualificationNo: null,
        certificateName: null,
        certificateNumber: null,
        effectBegin: null,
        certificateType: null,
        effectEnd: null,
        appIds: null,
        version: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询企业资质列表 */
    getList() {
      this.loading = true;
      listBusinessqualification(this.queryParams).then(response => {
        this.businessqualificationList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        pid: null,
        tenantId: null,
        qualificationNo: null,
        certificateName: null,
        certificateNumber: null,
        effectBegin: null,
        certificateType: null,
        effectEnd: null,
        appIds: null,
        version: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.pid)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加企业资质";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const pid = row.pid || this.ids
      getBusinessqualification(pid).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改企业资质";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.pid != null) {
            updateBusinessqualification(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addBusinessqualification(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const pids = row.pid || this.ids;
      this.$modal.confirm('是否确认删除企业资质编号为"' + pids + '"的数据项？').then(function() {
        return delBusinessqualification(pids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('creditlibrary/businessqualification/export', {
        ...this.queryParams
      }, `businessqualification_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
